var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForwardicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4028 11.1422C14.0068 10.5004 14.0068 9.4994 13.4028 8.85765L7.27366 2.34545C6.95823 2.01031 6.43084 1.99432 6.09569 2.30975C5.76055 2.62518 5.74457 3.15258 6.06 3.48772L12.1891 9.99992L6.06 16.5121C5.74457 16.8473 5.76055 17.3747 6.09569 17.6901C6.43084 18.0055 6.95824 17.9895 7.27367 17.6544L13.4028 11.1422Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardicon);
export default __webpack_public_path__ + "static/media/forwardicon.2311cb60ff1d1c7051709bde1a793545.svg";
export { ForwardRef as ReactComponent };